import { getUserRole } from 'src/utils/funcUtils';

const AccessControl = ({ hiddenRoles, children }) => {
  const userRole = getUserRole();
  return hiddenRoles?.length && hiddenRoles?.includes(userRole) ? null : children;
};

export default AccessControl;
